import { stepTypes } from '../constants/data-types';

const formatSectionErrors = (sectionIndexOrKey, validationErrs, stepType) => {
  if (stepType === stepTypes.QUESTION) {
    if (
      !validationErrs?.sections ||
      !validationErrs.sections[sectionIndexOrKey]
    ) {
      return {};
    }

    const sectionErrors = validationErrs.sections[sectionIndexOrKey];
    const formattedErrors = {
      items: {},
    };

    if (sectionErrors.title) {
      formattedErrors.title = sectionErrors.title;
    }

    Object.keys(sectionErrors).forEach((key) => {
      const match = key.match(/items\[(\d+)\]/);

      if (match) {
        const itemIndex = match[1];
        formattedErrors.items[itemIndex] = {
          title: sectionErrors[key],
        };
      }
    });

    return formattedErrors;
  } else if (stepType === stepTypes.DEFAULT) {
    const sectionErrors = validationErrs?.[sectionIndexOrKey] || {};

    return {
      items: sectionErrors,
    };
  }

  return {};
};

export default formatSectionErrors;
